const updates = [
  {
    date: '2026.07.31',
    tag: '新剧上线',
    title: '《暗夜追光》全24集完整版上线',
    desc: '悬疑犯罪题材年度力作，豆瓣开分8.7，全网热议不断，高清画质即点即播。',
  },
  {
    date: '2026.07.30',
    tag: '剧集更新',
    title: '《长安浮生录》第38集更新',
    desc: '古装权谋大剧持续热播，本集剧情大反转，智能推荐同步推送相关剧集。',
  },
  {
    date: '2026.07.29',
    tag: '电影上线',
    title: '院线大片《星际迷途3》高清版独家上线',
    desc: '科幻巨制震撼来袭，4K修复画质，电影大全片库再添重磅新成员。',
  },
  {
    date: '2026.07.28',
    tag: '专题策划',
    title: '「暑期追剧指南」专题页面上线',
    desc: '精选50部高分好剧，涵盖悬疑、甜宠、古装、科幻四大类型，快速找片不迷茫。',
  },
  {
    date: '2026.07.27',
    tag: '系统升级',
    title: '播放器全面升级，1080P画质默认开启',
    desc: '优化视频加载速度，实现真正的不缓冲流畅播放体验，追剧更畅快。',
  },
  {
    date: '2026.07.26',
    tag: '片库扩容',
    title: '新增韩剧专区，热门韩剧全集收录',
    desc: '《海岸村恰恰恰》《黑暗荣耀》等口碑韩剧完整版上线，高清在线观看。',
  },
  {
    date: '2026.07.25',
    tag: '功能更新',
    title: '智能推荐算法全面升级',
    desc: '根据您的观看历史和偏好，精准推送最新剧集，追剧体验更个性、更贴心。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">平台更新快讯，随时掌握最新影视资源动态</p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-8">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 items-start ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline dot on desktop */}
                <div className="hidden md:flex absolute left-1/2 top-2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 z-10"></div>

                {/* Content card */}
                <div className={`flex-1 ${i % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'}`}>
                  <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="text-xs text-foreground-400">{item.date}</span>
                      <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}